import { branch, compose, renderNothing } from 'recompose';
import { canUserUseBlockTime } from '../../../../../common/helpers/users';
import BlockTimeButton from '../components/BlockTimeButton';
import withPermissions from '../../../../../auth/utils/withPermissions';

const BlockTimeButtonContainer = compose(
  withPermissions,
  branch(
    props => !canUserUseBlockTime(props.permissions),
    renderNothing
  ),
)(BlockTimeButton);

export default BlockTimeButtonContainer;
